import { ButtonPrimary } from 'components/Button'
import { LightCard } from 'components/Card'
import Column from 'components/Column'
import Row from 'components/Row'
import ConfirmationTransactionStep, {
  ConfirmationTransactionStepProps,
} from 'components/StepLine/common/ConfirmationTransactionStep'
import { Check } from 'react-feather'
import styled, { useTheme } from 'styled-components'

const StyledListItem = styled(Row)`
  padding: 12px 0;
  gap: 12px;
  align-items: center;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.backgroundOutline};
  }
`

const CheckIcon = styled(Check)`
  color: ${({ theme }) => theme.accentSuccess};
  background: ${({ theme }) => `${theme.accentSuccess}1A`};
  padding: 4px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
`

const Description = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.textSecondary};
  margin: 0 0 24px 0;
  line-height: 1.5;
`

const BenefitText = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.textPrimary};
`

type DeployFarmStepProps = {
  next: () => void
  onStart: () => Promise<void>
  farmAddress: string
  onDismiss: () => Promise<void>
  // config: FarmConfig
} & Omit<ConfirmationTransactionStepProps, 'children' | 'onConfirm'>

export default function DeployFarmConfigStep({ next, onStart, onDismiss, farmAddress, ...rest }: DeployFarmStepProps) {
  const theme = useTheme()

  const benefits = [
    {
      text: 'Deploy new farm contract',
      description: 'Users can start staking and earning rewards',
    },
    {
      text: 'Configure reward token distribution',
      description: 'Define reward amounts and managers for each token',
    },
    {
      text: 'Set staking token and farm parameters',
      description: 'Customize farm settings like staking cap and lock time',
    },
  ]

  return (
    <ConfirmationTransactionStep {...rest} onConfirm={next}>
      <Column width="100%" gap="24px">
        <Description>Review the farm configuration before deployment:</Description>

        <LightCard>
          {benefits.map((benefit, index) => (
            <StyledListItem key={index}>
              <CheckIcon />
              <Column gap="4px">
                <BenefitText>{benefit.text}</BenefitText>
                <span style={{ fontSize: '14px', color: theme.textSecondary }}>{benefit.description}</span>
              </Column>
            </StyledListItem>
          ))}
        </LightCard>

        <ButtonPrimary onClick={onStart} style={{ marginTop: '8px' }}>
          Deploy Farm
        </ButtonPrimary>
      </Column>
    </ConfirmationTransactionStep>
  )
}
